<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="common-page-contentwrap">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
            <li><a>Market Connect</a></li>
          </ul>
      </div>
      <!-- breadcrumb End -->
    </div>
  </div>
  <div class="row">
    <div class="row">
      <div class="col-xs-12">
        <div class="col-xs-12 col-lg-6">
          <input type="button" class="readingsdays" value="Today"
                 (click)="selectedDate('today');"
                 [ngClass]="noOfDays=='today'?'selected-btn':'unselected-btn'">
          <input type="button" class="readingsdays" value="Week"
                 (click)="selectedDate('oneweek');"
                 [ngClass]="noOfDays=='oneweek'?'selected-btn':'unselected-btn'">
          <input type="button" class="readingsdays" value="Month"
                 (click)="selectedDate('onemonth');"
                 [ngClass]="noOfDays=='onemonth'?'selected-btn':'unselected-btn'">
          <input type="button" class="readingsdays" value="Year"
                 (click)="selectedDate('oneyear');"
                 [ngClass]="noOfDays=='oneyear'?'selected-btn':'unselected-btn'">
          <input type="button" class="readingsdays" value="Custom" (click)="selectedDate('Custom');" *ngIf="customFromDate == '' && customToDate == ''"
                 [ngClass]="noOfDays == 'Custom' || (customFromDate != '' && customToDate != '') ? 'selected-btn' : 'unselected-btn'">
          <span (click)="selectedDate('Custom');" *ngIf="customFromDate != '' && customToDate != ''" [ngClass]="noOfDays === 'Custom' || (customFromDate !== '' && customToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customFromDate}} - {{ customToDate }}</span>
          <app-date-range-popup
            *ngIf="isDateRangePopupOpen"
            [fromDate]="customFromDate"
            [toDate]="customToDate"
            (close)="closeDateRangePopup()"
            (apply)="onDateRangeApply($event)">
          </app-date-range-popup>
        </div>
        <div class="col-xs-12 col-lg-6">
          <div class="globalicons">
            <span (click)="makeData('total'); changeColor('total')"
                  [ngClass]="culturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
            <span (click)="makeData('shrimp'); changeColor('shrimp')" title="Shrimp"
                  [ngClass]="culturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
              src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
            <span (click)="makeData('fish'); changeColor('fish')" title="Fish"
                  [ngClass]="culturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
              src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row cards-block">
    <div class="col-lg-12">
      <div class="col-lg-3 hatchery-block"></div>
      <!--market connect card-->
      <div class="col-lg-6 market-connect-block">
        <h4 class="marketconnect">Market Connect</h4>
        <div class="marketCard">
          <!-- <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-3">
                <p class="leadincrement"><span
                  *ngIf="bluHatchLeads > hatcheryLeadRegistredCount">+</span>{{bluHatchLeads - hatcheryLeadRegistredCount}}
                </p>
              </div>
              <div class="col-xs-3">
                <p class="leadcount">{{bluHatchLeads}}</p>
              </div>
              <div class="col-xs-3">
                <p class="convertincrement"><span
                  *ngIf="bluHatchLeadsConverted > hatcheryLeadsConvertedCount">+</span>{{bluHatchLeadsConverted - hatcheryLeadsConvertedCount}}
                </p>
              </div>
              <div class="col-xs-3">
                <p class="convertcount">{{bluHatchLeadsConverted}}</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-6">
                <p class="leadtitle">BluHatch leads</p>
              </div>
              <div class="col-xs-6">
                <p class="converttitle">Converted</p>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-3">
                <p class="leadincrement"><span
                  *ngIf="blubayLeads > blubayLeadsRegistredCount">+</span>{{blubayLeads - blubayLeadsRegistredCount}}
                </p>
              </div>
              <div class="col-xs-3">
                <p class="leadcount">{{blubayLeads}}</p>
              </div>
              <div class="col-xs-3">
                <p class="convertincrement"><span
                  *ngIf="blubayLeadsConverted > blubayLeadsConvertedCount">+</span>{{blubayLeadsConverted - blubayLeadsConvertedCount}}
                </p>
              </div>
              <div class="col-xs-3">
                <p class="convertcount">{{blubayLeadsConverted}}</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-6">
                <p class="leadtitle blubayleadtitle">Leads</p>
              </div>
              <div class="col-xs-6">
                <p class="converttitle">Converted</p>
              </div>
            </div>
          </div>
          <div>
            <p class="details marketconnectdetails"><span class="detailsicon"><img title="Details" (click)="getMarketConnectDetails()"
                                                                                   src="../../../../assets/img/marcketconnectreports/Report.svg"/></span>
              <span class="trends"><img title="Graph" (click)="getMarketConnectTrends()"
                                        src="../../../../assets/img/marcketconnectreports/Graph_purple.svg"
                                        width="18"/></span>
              <!-- <span class="trends"><img title="Analytics" (click)="googleAnalytics()"
                                          src="../../../../assets/img/marcketconnectreports/analytics-Blue.svg"
                                          width="18"/></span> -->
            </p>
          </div>
        </div>
      </div>
      <!--market connect card edn -->
      <div class="col-lg-3 hatchery-block"></div>
    </div>
    <div class="col-lg-12 mobilepadding" style="margin-top: 30px">
      <!-- <div class="col-lg-4 hatchery-block mobilepadding">
        <h4>Hatcheries</h4>
        <div class="card">
          <span class="cardinfo" *ngIf="hatcheryRegistred > incrementHatcheryRegister"><img class="arrowimage"
                                                                                            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="hatcheryRegistred < incrementHatcheryRegister"><img class="arrowimage"
                                                                                            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="hatcheryRegistred == incrementHatcheryRegister"><img class="arrowimage"
                                                                                             src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Hatcheries Registered</span>
          <div style="float: right;">
            <span class="count">{{hatcheryRegistred}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="demoRequest > incrementHatcheryDemoReq"><img class="arrowimage"
                                                                                     src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="demoRequest < incrementHatcheryDemoReq"><img class="arrowimage"
                                                                                     src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="demoRequest == incrementHatcheryDemoReq"><img class="arrowimage"
                                                                                      src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Demo Request</span>
          <div style="float: right;">
            <span class="count">{{demoRequest}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="seedPosted > incrementHatcherySeed"><img class="arrowimage"
                                                                                 src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="seedPosted < incrementHatcherySeed"><img class="arrowimage"
                                                                                 src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="seedPosted == incrementHatcherySeed"><img class="arrowimage"
                                                                                  src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Seeds posted</span>
          <div style="float: right;">
            <span class="count">{{seedPosted}}</span>
          </div>
        </div>
        <div class="lastcard">
          <span class="cardinfo" *ngIf="leadReceived > incrementHatcheryLeed"><img class="arrowimage"
                                                                                   src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="leadReceived < incrementHatcheryLeed"><img class="arrowimage"
                                                                                   src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="leadReceived == incrementHatcheryLeed"><img class="arrowimage"
                                                                                    src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Leads Received</span>
          <div style="float: right;">
            <span class="count">{{leadReceived}}</span>
          </div>
          <p class="details" (click)="getHatcheryDetails()"><span class="detailsicon"><img title="Details"
                                                                 src="../../../../assets/img/marcketconnectreports/Report.svg"/></span>
          </p>
        </div>
      </div> -->
      <!--farms card-->
      <div class="col-lg-6 hatchery-block">
        <h4 class="marketconnect">Farms</h4>
        <div class="card">
          <span class="cardinfo" *ngIf="farmsRegistred > incrementFarmRegister"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="farmsRegistred < incrementFarmRegister"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="farmsRegistred == incrementFarmRegister"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Farms Registered</span>
          <div style="float: right;">
            <span class="count">{{farmsRegistred}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="farmsDemoRequests > incrementFarmDemoReq"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="farmsDemoRequests < incrementFarmDemoReq"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="farmsDemoRequests == incrementFarmDemoReq"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Demo Request</span>
          <div style="float: right;">
            <span class="count">{{farmsDemoRequests}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="farmsSeedRequest > incrementFarmSeed"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="farmsSeedRequest < incrementFarmSeed"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="farmsSeedRequest == incrementFarmSeed"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Seed Request</span>
          <div style="float: right;">
            <span class="count">{{farmsSeedRequest}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="farmsStockLeads > incrementFarmsStockLeads"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="farmsStockLeads < incrementFarmsStockLeads"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="farmsStockLeads == incrementFarmsStockLeads"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Stock leads</span>
          <div style="float: right;">
            <span class="count">{{farmsStockLeads}}</span>
          </div>
        </div>
        <div class="lastcard">
          <span class="cardinfo" *ngIf="farmsQuoteRequest > incrementFarmLeed"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="farmsQuoteRequest < incrementFarmLeed"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="farmsQuoteRequest == incrementFarmLeed"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Quote Request</span>
          <div style="float: right;">
            <span class="count">{{farmsQuoteRequest}}</span>
          </div>
          <p class="details" (click)="getFarmsDetails()"><span class="detailsicon"><img title="Details"
                                                                                        src="../../../../assets/img/marcketconnectreports/Report.svg"/></span>
          </p>
        </div>
      </div>
      <!--farms card end-->
      <!--Buyers card-->
      <div class="col-lg-6 hatchery-block">
        <h4 class="marketconnect">Buyers</h4>
        <div class="card">
          <span class="cardinfo" *ngIf="buyersRegistred > incrementBuyerRegister"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="buyersRegistred < incrementBuyerRegister"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="buyersRegistred == incrementBuyerRegister"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Buyers registered</span>
          <div style="float: right;">
            <span class="count">{{buyersRegistred}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="buyersDemoRequests > incrementBuyerDemoReq"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="buyersDemoRequests < incrementBuyerDemoReq"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="buyersDemoRequests == incrementBuyerDemoReq"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Demo Request</span>
          <div style="float: right;">
            <span class="count">{{buyersDemoRequests}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="buyersStockRequest > incrementBuyerStock"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="buyersStockRequest < incrementBuyerStock"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="buyersStockRequest == incrementBuyerStock"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Stock Request</span>
          <div style="float: right;">
            <span class="count">{{buyersStockRequest}}</span>
          </div>
        </div>
        <div class="card">
          <span class="cardinfo" *ngIf="buyerLeadsRequest > incrementBuyerLeed"><img
            src="../../../../assets/img/marcketconnectreports/Up.svg"></span>
          <span class="cardinfo" *ngIf="buyerLeadsRequest < incrementBuyerLeed"><img
            src="../../../../assets/img/marcketconnectreports/Down.svg"></span>
          <span class="cardinfo" *ngIf="buyerLeadsRequest == incrementBuyerLeed"><img
            src="../../../../assets/img/marcketconnectreports/nochange.svg"></span>
          <span class="cardinfo">Leads to Request</span>
          <div style="float: right;">
            <span class="count">{{buyerLeadsRequest}}</span>
          </div>
        </div>
        <div class="lastcard">
          <span class="cardinfo"></span>
          <span class="cardinfo"></span>
          <span class="cardinfo"></span>
          <span class="cardinfo"></span>
          <div style="float: right;">
            <span class="count"></span>
          </div>
          <p class="details" (click)="getBuyersDetails()"><span class="detailsicon"><img title="Details"
                                                                                        src="../../../../assets/img/marcketconnectreports/Report.svg"/></span>
          </p>
        </div>
      </div>
      <!--Buyers card end-->
    </div>
  </div>
  <!--Details table for hatchery, market connect and farms-->
  <div id="parent_element">
    <!--hatchery table data-->
    <div id="hatcheryreport">
      <div *ngIf="hatcheryResponseLoader">
        <div class="adjust">
          <div class="reports-loader"></div>
        </div>
      </div>
      <div class="row card-container" id="hatcheryCardContainer" *ngIf="showHatcheryDetails && !hatcheryResponseLoader"
           style="margin-top: 2%;margin-bottom: 2%">
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-4">
            <p class="tableheading">Hatcheries - Report</p>
          </div>
          <div class="col-xs-4">
            <div class="hatcheryglobalicons">
         <span (click)="tableCultureSeletion('total'); addBoxSahadow('total')"
               [ngClass]="tableculturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
              <span (click)="tableCultureSeletion('shrimp'); addBoxSahadow('shrimp')" title="Shrimp"
                    [ngClass]="tableculturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
              <span (click)="tableCultureSeletion('fish'); addBoxSahadow('fish')" title="Fish"
                    [ngClass]="tableculturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
            </div>
          </div>
          <div class="col-xs-4" style="padding: 0">
            <nav class="navbar tableactions">
              <div class="container-fluid actionpoints">
                <ul class="nav navbar-nav navbar-right">
                  <li (click)="exportExcel('Hatcheries Report')" title="Export"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a></li>
                  <li title="Share" (click)="mail_content()"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                  </li>
                  <li class="zoomin" (click)="openFullScreen('hatcheryCardContainer')"><a><img title="Zoom in"
                                                                                               src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                               width="18"></a></li>
                  <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                          src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                          width="18"></a></li>
                  <li class="closebtn" (click)="closeTable('hatcheriesdetails')"><a><img title="Close"
                                                                                         src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                         width="18"></a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
            <div class="col-xs-4">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <li class="active" (click)="tableSectionTab('Hatchery', $event)"><a data-toggle="tab" href="#Hatcheries">Hatcheries</a>
                  </li>
                  <!--<li (click)="tableSectionTab('Farm')"><a data-toggle="tab" href="#Farms">Farms</a></li>-->
                </ul>
              </div>
            </div>
            <div class="col-xs-3">
              <div class="search">
                <img src="../../../../../../assets/img/png-icons-blubay/search_icon.svg" width="20" height="20" class="search_icon">
                <input type="text" class="search_input" (keyup)="searchLead('hatcheries', $event)" [(ngModel)]="hatcherySearch" name="search" autocomplete="off" placeholder="Search by any field">
                <img src="../../../../../../assets/img/png-icons-blubay/search_close_icon.svg" width="20" height="20" class="search_close" *ngIf="clearHatcherySearchInput" (click)="this.hatcherySearch = '';this.clearHatcherySearchInput = false;searchLead('hatcheries', $event)">
              </div>
            </div>
            <div class="col-xs-5">
              <P class="daysselection">
                <input type="button" class="readingsdays" value="Today"
                       (click)="tableDays('today');"
                       [ngClass]="tablenoOfDays=='today'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Week"
                       (click)="tableDays('oneweek');"
                       [ngClass]="tablenoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Month"
                       (click)="tableDays('onemonth');"
                       [ngClass]="tablenoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Year"
                       (click)="tableDays('oneyear');"
                       [ngClass]="tablenoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Custom" (click)="tableDays('Custom');" *ngIf="customHatcheryFromDate == '' && customHatcheryToDate == ''"
                       [ngClass]="tablenoOfDays=='Custom'?'selected-btn':'unselected-btn'">
                <span (click)="tableDays('Custom');" *ngIf="customHatcheryFromDate != '' && customHatcheryToDate != ''" [ngClass]="tablenoOfDays === 'Custom' || (customHatcheryFromDate !== '' && customHatcheryToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customHatcheryFromDate}} - {{ customHatcheryToDate }}</span>
              </P>
              <app-date-range-popup
                *ngIf="isHatcheryDateRangePopupOpen"
                [fromDate]="customHatcheryFromDate"
                [toDate]="customHatcheryToDate"
                (close)="closeHatcheryDateRangePopup()"
                (apply)="onHatcheryDateRangeApply($event)">
              </app-date-range-popup>
            </div>
          </div>
        </div>
        <div class="row table-responsive" style="padding: 12px 14px;">
          <table class="table" *ngIf="dispFinalData?.length > 0" id="cartcontent">
            <thead>
            <tr>
              <th>S.No</th>
              <th>Date & Time</th>
              <th>Person Name</th>
              <th>Location</th>
              <th>Contact Number</th>
              <th>Description</th>
              <th>Status</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="hatcherytablebody">
            <tr class="searchfun"
                *ngFor="let list of dispFinalData; let i = index">
              <td>{{i+1}}</td>
              <td>{{list && list.generatedDate | date:"dd MMM yyyy"}}</td>
              <td>{{list && list.personName ? list && list.personName : '--'}}</td>
              <td>{{list && list.location ? list && list.location : '--'}}</td>
              <td>{{list && list.dialingCode}} {{list && list.mobileNumber ? list && list.mobileNumber : '--'}}</td>
              <td>{{list && list.event ? list && list.event : '--'}}</td>
              <td>{{list && list.status ? list && list.status : '--'}}</td>
              <td>
                <p class="statusaction">
                  <img src="../../../../assets/img/marcketconnectreports/followup.svg" *ngIf="list.status != 'FollowUp'"
                       (click)="statusAction(list.id, list.event, 'follow', 'hatchery', (currentpagenum - 1) * noofitemsPerPage + i)" title="Follow Up">
                  <img src="../../../../assets/img/marcketconnectreports/followup_Gray.svg"
                       *ngIf="list.status == 'FollowUp'">
                  <img src="../../../../assets/img/marcketconnectreports/close_1.svg" *ngIf="list.status != 'Closed'"
                       (click)="statusAction(list.id, list.event, 'close', 'hatchery', (currentpagenum - 1) * noofitemsPerPage + i)" title="Close">
                  <img src="../../../../assets/img/marcketconnectreports/close_gray.svg"
                       *ngIf="list.status == 'Closed'">
                  <img src="../../../../assets/img/marcketconnectreports/archive.svg" *ngIf="list.status != 'Archived'"
                       (click)="statusAction(list.id, list.event, 'archive', 'hatchery', (currentpagenum - 1) * noofitemsPerPage + i)" title="Archived">
                  <img src="../../../../assets/img/marcketconnectreports/archive_gray.svg"
                       *ngIf="list.status == 'Archived'">
                  <img src="../../../../assets/img/marcketconnectreports/assgin.svg" *ngIf="list.status != 'Assigned'"
                       (click)="statusAction(list.id, list.event, 'assigned', 'hatchery', (currentpagenum - 1) * noofitemsPerPage + i)" title="Assign">
                  <img src="../../../../assets/img/marcketconnectreports/assign_gray.svg"
                       *ngIf="list.status == 'Assigned'">
                </p>
              </td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div> 
          <div *ngIf="dispFinalData?.length <= 0" class="noDataFoundMessage">No Data Available</div>
        </div>
      </div>
    </div>
    <!--market connect details table-->
    <div id="marketreport">
      <div *ngIf="responseLoader">
        <div class="adjust">
          <div class="reports-loader"></div>
        </div>
      </div>
      <div class="row card-container marketcard-container" id="marketCardContainer" *ngIf="showMarketConnectDetails && !responseLoader"
           style="margin-top: 2%; margin-bottom: 2%">
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-4">
            <p class="tableheading">Market Connect - Report</p>
          </div>
          <div class="col-xs-4">
            <div class="hatcheryglobalicons">
         <span (click)="marketConnectTableCultureSelection('total'); marketconnectaddBoxSahadow('total')"
               [ngClass]="marketconnecttableculturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
              <span (click)="marketConnectTableCultureSelection('shrimp'); marketconnectaddBoxSahadow('shrimp')"
                    title="Shrimp"
                    [ngClass]="marketconnecttableculturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
              <span (click)="marketConnectTableCultureSelection('fish'); marketconnectaddBoxSahadow('fish')"
                    title="Fish"
                    [ngClass]="marketconnecttableculturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
            </div>
          </div>
          <div class="col-xs-4" style="padding:0">
            <nav class="navbar tableactions">
              <div class="container-fluid actionpoints">
                <ul class="nav navbar-nav navbar-right">
                  <li title="Export" (click)="exportExcel('Market Connect Report')"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a>
                  </li>
                  <li title="Share"><a><span><img src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                  </li>
                  <li class="zoomin" (click)="openFullScreen('marketCardContainer')"><a><img title="Zoom in"
                                                                                             src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                             width="18"></a></li>
                  <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                          src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                          width="18"></a></li>
                  <li class="closebtn" (click)="closeTable('marketconnect')"><a><img title="Close"
                                                                                     src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                     width="18"></a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="row"style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
            <div class="col-xs-4">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <!-- <li class="active" (click)="marketconnecttableSectionTab('Hatchery')"><a data-toggle="tab"
                                                                                             href="#Hatcheries">Hatcheries</a>
                  </li> -->
                  <li class="active" (click)="marketconnecttableSectionTab('Farm')"><a data-toggle="tab" href="#Farms">Farms</a></li>
                  <li (click)="marketconnecttableSectionTab('Buyer')"><a data-toggle="tab" href="#Buyer">Buyer</a></li>
                </ul>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="search">
                <img src="../../../../../../assets/img/png-icons-blubay/search_icon.svg" width="20" height="20" class="search_icon">
                <input type="text" class="search_input" (keyup)="searchLead('marketconnect', $event)" [(ngModel)]="marketConnectSearch" name="search" autocomplete="off" placeholder="Search by any field">
                <img src="../../../../../../assets/img/png-icons-blubay/search_close_icon.svg" width="20" height="20" class="search_close" *ngIf="clearMCSearchInput" (click)="this.marketConnectSearch = '';clearMCSearchInput=false;searchLead('marketconnect', $event)">
              </div>
            </div>
            <div class="col-xs-4">
              <P class="daysselection">
                <input type="button" class="readingsdays" value="Today"
                       (click)="marketconnecttableDays('today');"
                       [ngClass]="marketconnecttablenoOfDays=='today'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Week"
                       (click)="marketconnecttableDays('oneweek');"
                       [ngClass]="marketconnecttablenoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Month"
                       (click)="marketconnecttableDays('onemonth');"
                       [ngClass]="marketconnecttablenoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Year"
                       (click)="marketconnecttableDays('oneyear');"
                       [ngClass]="marketconnecttablenoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Custom" (click)="marketconnecttableDays('Custom');" *ngIf="customMCREPFromDate == '' && customMCREPToDate == ''"
                       [ngClass]="marketconnecttablenoOfDays=='Custom'?'selected-btn':'unselected-btn'">
                <span (click)="marketconnecttableDays('Custom');" *ngIf="customMCREPFromDate != '' && customMCREPToDate != ''" [ngClass]="marketconnecttablenoOfDays === 'Custom' || (customMCREPFromDate !== '' && customMCREPToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customMCREPFromDate}} - {{ customMCREPToDate }}</span>
              </P>
              <app-date-range-popup
                *ngIf="isMCREPDateRangePopupOpen"
                [fromDate]="customMCREPFromDate"
                [toDate]="customMCREPToDate"
                (close)="closeMCREPDateRangePopup()"
                (apply)="onMCREPDateRangeApply($event)">
              </app-date-range-popup>
            </div>
          </div>
        </div>
        <div class="row table-responsive" style="padding: 12px 14px;">
          <table class="table" *ngIf="dispmarketconnectfinalData?.length > 0">
            <thead>
            <tr>
              <th>S.No</th>
              <th>Date & Time</th>
              <th *ngIf="hatcheryName">Hatchery Name</th>
              <th *ngIf="farmName">Farm Name</th>
              <th *ngIf="hatcheryName || farmName">Location Name</th>
              <th>Contact Number</th>
              <th>Country</th>
              <th>Description</th>
              <th>Status</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="hatcherytablebody">
            <tr (click)="buyerLocationName && getPersonDetails(list.mobileNumber)" [ngClass]="{'hover-highlight': buyerLocationName}"
              *ngFor="let list of dispmarketconnectfinalData; let i = index">
              <td>{{i+1}}</td>
              <td>{{list && list.generatedDate | date:"dd MMM yyyy"}}</td>
              <td *ngIf="farmName || hatcheryName">{{list && list.businessName ? list && list.businessName : '--'}}</td>
              <td *ngIf="farmName || hatcheryName">{{list && list.farmSiteName ? list && list.farmSiteName : '--'}}</td>
              <td>{{list && list.dialingCode}} {{list && list.mobileNumber ? list && list.mobileNumber : '--'}}</td>
              <td>{{list && list.name ? list && list.name : '--'}}</td>
              <td>{{list && list.event ? list && list.event : '--'}}</td>
              <td>{{list && list.status ? list && list.status : '--'}}</td>
              <td>
                <p class="marketconnectactions">
                  <img src="../../../../assets/img/marcketconnectreports/followup.svg" *ngIf="list.status != 'FollowUp'"
                       (click)="statusAction(list.id, list.event, 'follow', 'marketconnect', (marketcurrentpagenum - 1) * marketnoofitemsPerPage + i)" title="Follow Up">
                  <img src="../../../../assets/img/marcketconnectreports/followup_Gray.svg"
                       *ngIf="list.status == 'FollowUp'">
                  <img src="../../../../assets/img/marcketconnectreports/close_1.svg" *ngIf="list.status != 'Closed'"
                       (click)="statusAction(list.id, list.event, 'close', 'marketconnect', (marketcurrentpagenum - 1) * marketnoofitemsPerPage + i)" title="Close">
                  <img src="../../../../assets/img/marcketconnectreports/close_gray.svg"
                       *ngIf="list.status == 'Closed'">
                  <img src="../../../../assets/img/marcketconnectreports/archive.svg" *ngIf="list.status != 'Archived'"
                       (click)="statusAction(list.id, list.event, 'archive', 'marketconnect', (marketcurrentpagenum - 1) * marketnoofitemsPerPage + i)" title="Archive">
                  <img src="../../../../assets/img/marcketconnectreports/archive_gray.svg"
                       *ngIf="list.status == 'Archived'">
                  <img src="../../../../assets/img/marcketconnectreports/assgin.svg" *ngIf="list.status != 'Assigned'"
                       (click)="statusAction(list.id, list.event, 'assigned', 'marketconnect', (marketcurrentpagenum - 1) * marketnoofitemsPerPage + i)" title="Assign">
                  <img src="../../../../assets/img/marcketconnectreports/assign_gray.svg"
                       *ngIf="list.status == 'Assigned'">
                </p>
              </td>
            </tr>
            </tbody>
          </table>
           <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <div *ngIf="dispmarketconnectfinalData?.length <= 0" class="noDataFoundMessage">No Data Available</div>
        </div>
      </div>
    </div>
    <!--market connect details graph-->
    <div id="marketconnectgraph">
      <div class="row card-container marketgraphcard-container" id="marketcardgraph" *ngIf="showMarketConnectTrends"
           style="margin-top: 2%; margin-bottom: 2%">
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-4">
            <p class="tableheading">Market Connect - Trends</p>
          </div>
          <div class="col-xs-4">
            <div class="hatcheryglobalicons">
              <span (click)="marketConnectTableGraphCultureSelection('total'); marketconnectGraphaddBoxSahadow('total')"
               [ngClass]="marketconnecttableGraphculturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
              <span (click)="marketConnectTableGraphCultureSelection('shrimp'); marketconnectGraphaddBoxSahadow('shrimp')"
                    title="Shrimp"
                    [ngClass]="marketconnecttableGraphculturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
              <span (click)="marketConnectTableGraphCultureSelection('fish'); marketconnectGraphaddBoxSahadow('fish')"
                    title="Fish"
                    [ngClass]="marketconnecttableGraphculturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
            </div>
          </div>
          <div class="col-xs-4" style="padding:0">
            <nav class="navbar tableactions">
              <div class="container-fluid actionpoints">
                <ul class="nav navbar-nav navbar-right">
                  <!--<li title="Export" (click)="exportExcel()"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a>
                  </li>-->
                  <li title="Share"><a><span><img src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                  </li>
                  <li class="zoomin" (click)="openFullScreen('marketcardgraph')"><a><img title="Zoom in"
                                                                                             src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                             width="18"></a></li>
                  <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                          src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                          width="18"></a></li>
                  <li class="closebtn" (click)="closeTable('marketconnectgraph')"><a><img title="Close"
                                                                                     src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                     width="18"></a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
            <div class="col-xs-6">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <!-- <li class="active" (click)="marketconnecttableGraphSectionTab('Hatchery')"><a data-toggle="tab"
                                                                                             href="#Hatcheries">Hatcheries</a>
                  </li> -->
                  <li class="active" (click)="marketconnecttableGraphSectionTab('Farm')"><a data-toggle="tab" href="#Farms">Farms</a></li>
                </ul>
              </div>
            </div>
            <div class="col-xs-6">
              <P class="daysselection">
                <input type="button" class="readingsdays" value="Today"
                       (click)="marketconnecttableGraphDays('today');"
                       [ngClass]="marketconnecttableGraphnoOfDays=='today'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Week"
                       (click)="marketconnecttableGraphDays('oneweek');"
                       [ngClass]="marketconnecttableGraphnoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Month"
                       (click)="marketconnecttableGraphDays('onemonth');"
                       [ngClass]="marketconnecttableGraphnoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Year"
                       (click)="marketconnecttableGraphDays('oneyear');"
                       [ngClass]="marketconnecttableGraphnoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Custom" (click)="marketconnecttableGraphDays('Custom');" *ngIf="customMCFromDate == '' && customMCToDate == ''"
                       [ngClass]="marketconnecttableGraphnoOfDays=='Custom'?'selected-btn':'unselected-btn'">
                <span (click)="marketconnecttableGraphDays('Custom');" *ngIf="customMCFromDate != '' && customMCToDate != ''" [ngClass]="marketconnecttableGraphnoOfDays === 'Custom' || (customMCFromDate !== '' && customMCToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customMCFromDate}} - {{ customMCToDate }}</span>
              </P>
            </div>
            <app-date-range-popup
              *ngIf="isMCDateRangePopupOpen"
              (close)="closeMCDateRangePopup()"
              (apply)="onMCDateRangeApply($event)">
            </app-date-range-popup>
          </div>
        </div>
        <div id="chartContainer" style="height: 450px; width: 100%; margin: 3% 0;"></div>
      </div>
    </div>
    <!--google analytics-->
    <div id="googleanalyticsreport">
      <div class="row card-container analytics-container" id="googleanalytics" *ngIf="showGoogleAnalytics"
           style="margin-top: 2%; margin-bottom: 2%">
        <div class="row">
          <div class="col-xs-4">
            <p class="tableheading">Google Analytics</p>
          </div>
          <div class="col-xs-4">
            <div class="hatcheryglobalicons">
              <span (click)="analyticsCultureSelection('total'); analyticsBoxSahadow('total')"
                    [ngClass]="analyticsCulturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
              <span (click)="analyticsCultureSelection('shrimp'); analyticsBoxSahadow('shrimp')"
                    title="Shrimp"
                    [ngClass]="analyticsCulturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
              <span (click)="analyticsCultureSelection('fish'); analyticsBoxSahadow('fish')"
                    title="Fish"
                    [ngClass]="analyticsCulturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
            </div>
          </div>
          <div class="col-xs-4" style="padding:0">
            <nav class="navbar tableactions">
              <div class="container-fluid actionpoints">
                <ul class="nav navbar-nav navbar-right">
                  <li title="Export" (click)="exportExcel()"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a>
                  </li>
                  <li title="Share"><a><span><img src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                  </li>
                  <li class="zoomin" (click)="openFullScreen('googleanalytics')"><a><img title="Zoom in"
                                                                                         src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                         width="18"></a></li>
                  <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                          src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                          width="18"></a></li>
                  <li class="closebtn" (click)="closeTable('closegoogleanalytics')"><a><img title="Close"
                                                                                          src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                          width="18"></a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="row table-responsive" style="padding: 12px 14px;">
          <table class="table">
            <thead>
            <tr>
              <th>Active Users</th>
              <th>New Users</th>
            </tr>
            </thead>
            <tbody class="hatcherytablebody">
            <tr *ngFor="let list of analyticsUsersArray">
              <td>{{list.activeUsers}}</td>
              <td>{{list.newUser}}</td>
              <td>{{list.pageViews}}</td>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
            <div class="col-xs-">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <!-- <li class="active" (click)="analyticsSectionTab('hatcheries')"><a data-toggle="tab"
                                                                                                  href="#Hatcheries">Hatcheries</a>
                  </li> -->
                  <li class="active" (click)="analyticsSectionTab('farmer')"><a data-toggle="tab" href="#Farms">Farms</a></li>
                </ul>
              </div>
            </div>
            <div class="col-xs-4">
              <form class="form-inline">
                <input name="search" autocomplete="off" class="searchinput" placeholder="Search.." type="text"
                       (keyup)="searchLead('marketconnect', $event)">
                <img class="searchicon" src="../../../../assets/img/marcketconnectreports/search.svg">
              </form>
            </div>
            <div class="col-xs-4">
              <P class="daysselection">
                <input type="button" class="readingsdays" value="Today"
                       (click)="analyticsDays('today');"
                       [ngClass]="analyticsnoOfDays=='today'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Week"
                       (click)="analyticsDays('oneweek');"
                       [ngClass]="analyticsnoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Month"
                       (click)="analyticsDays('onemonth');"
                       [ngClass]="analyticsnoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Year"
                       (click)="analyticsDays('oneyear');"
                       [ngClass]="analyticsnoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Custom"
                       [ngClass]="analyticsnoOfDays=='Custom'?'selected-btn':'unselected-btn'">
              </P>
            </div>
          </div>
        </div>
        <div class="row table-responsive" style="padding: 12px 14px;">
          <table class="table">
            <thead>
            <tr>
              <th>S.No</th>
              <th>Event Name</th>
              <th>Event Count</th>
            </tr>
            </thead>
            <tbody class="hatcherytablebody">
            <tr *ngFor="let list of analyticsfinalData; let i = index ">
              <td>{{((analyticscurrentpagenum - 1) * analyticsnoofitemsPerPage) + i + 1}}</td>
              <td>{{list && list.eventName}}</td>
              <td>{{list && list.eventCount}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--farms connect details table-->
    <div id="farmsreport">
      <div *ngIf="FarmsResponseLoader">
        <div class="adjust">
          <div class="reports-loader"></div>
        </div>
      </div>
      <div class="row card-container farmscard-container" id="farmsCardContainer" *ngIf="showFarmsDetails && !FarmsResponseLoader"
           style="margin-top: 2%;margin-bottom: 2%">
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-4">
            <p class="tableheading">Farms - Report</p>
          </div>
          <div class="col-xs-4">
            <div class="hatcheryglobalicons">
         <span (click)="farmstableCultureSeletion('total'); farmsaddBoxSahadow('total')"
               [ngClass]="farmstableculturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
              <span (click)="farmstableCultureSeletion('shrimp'); farmsaddBoxSahadow('shrimp')" title="Shrimp"
                    [ngClass]="farmstableculturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
              <span (click)="farmstableCultureSeletion('fish'); farmsaddBoxSahadow('fish')" title="Fish"
                    [ngClass]="farmstableculturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
            </div>
          </div>
          <div class="col-xs-4" style="padding: 0">
            <nav class="navbar tableactions">
              <div class="container-fluid actionpoints">
                <ul class="nav navbar-nav navbar-right">
                  <li (click)="exportExcel('Farms Report')" title="Export"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a>
                  </li>
                  <li title="Share"><a><span><img src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                  </li>
                  <li class="zoomin" (click)="openFullScreen('farmsCardContainer')"><a><img title="Zoom in"
                                                                                            src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                            width="18"></a></li>
                  <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                          src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                          width="18"></a></li>
                  <li class="closebtn" (click)="closeTable('farmsdetails')"><a><img title="Close"
                                                                                    src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                    width="18"></a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
            <div class="col-xs-4">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <!--<li (click)="farmstableSectionTab('Hatchery')"><a data-toggle="tab" href="#Hatcheries">Hatcheries</a>
                  </li>-->
                  <li class="active" (click)="farmstableSectionTab('Farm')"><a data-toggle="tab"
                                                                                 href="#Farms">Farms</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="search">
                <img src="../../../../../../assets/img/png-icons-blubay/search_icon.svg" width="20" height="20" class="search_icon">
                <input type="text" class="search_input" (keyup)="searchLead('farms', $event)" [(ngModel)]="farmSearch" name="search" autocomplete="off" placeholder="Search by any field">
                <img src="../../../../../../assets/img/png-icons-blubay/search_close_icon.svg" width="20" height="20" class="search_close" *ngIf="clearFarmSearchInput" (click)="this.farmSearch = '';this.clearFarmSearchInput = false;searchLead('farms', $event)">
              </div>
            </div>
            <div class="col-xs-4">
              <P class="daysselection">
                <input type="button" class="readingsdays" value="Today"
                       (click)="farmstableDays('today');"
                       [ngClass]="farmstablenoOfDays=='today'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Week"
                       (click)="farmstableDays('oneweek');"
                       [ngClass]="farmstablenoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Month"
                       (click)="farmstableDays('onemonth');"
                       [ngClass]="farmstablenoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Year"
                       (click)="farmstableDays('oneyear');"
                       [ngClass]="farmstablenoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Custom" (click)="farmstableDays('Custom');" *ngIf="customFarmsFromDate == '' && customFarmsToDate == ''"
                       [ngClass]="farmstablenoOfDays=='Custom'?'selected-btn':'unselected-btn'">
                <span (click)="farmstableDays('Custom');" *ngIf="customFarmsFromDate != '' && customFarmsToDate != ''" [ngClass]="farmstablenoOfDays === 'Custom' || (customFarmsFromDate !== '' && customFarmsToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customFarmsFromDate}} - {{ customFarmsToDate }}</span>
              </P>
              <app-date-range-popup
                *ngIf="isFarmsDateRangePopupOpen"
                [fromDate]="customFarmsFromDate"
                [toDate]="customFarmsToDate"
                (close)="closeFarmsDateRangePopup()"
                (apply)="onFarmsDateRangeApply($event)">
              </app-date-range-popup>
            </div>
          </div>
        </div>
        <div class="row table-responsive" style="padding: 12px 14px;">
          <table class="table" *ngIf="(dispfarmsfinalData?.length > 0)">
            <thead>
            <tr>
              <th>S.No</th>
              <th>Date & Time</th>
              <th>Person Name</th>
              <th>Location</th>
              <th>Contact Number</th>
              <th>Description</th>
              <th>Status</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="hatcherytablebody">
            <tr class="searchfun"
                *ngFor="let list of dispfarmsfinalData; let i = index">
              <td>{{i+1}}</td>
              <td>{{list && list.generatedDate | date:"dd MMM yyyy"}}</td>
              <td>{{list && list.personName ? list && list.personName : '--'}}</td>
              <td>{{list && list.location ? list && list.location : '--'}}</td>
              <td>{{list && list.dialingCode}} {{list && list.mobileNumber ? list && list.mobileNumber : '--'}}</td>
              <td>{{list && list.event ? list && list.event : '--'}}</td>
              <td>{{list && list.status ? list && list.status : '--'}}</td>
              <td>
                <p class="statusaction">
                  <img src="../../../../assets/img/marcketconnectreports/followup.svg" *ngIf="list.status != 'FollowUp'"
                       title="Follow Up"
                       (click)="statusAction(list.id, list.event, 'follow', 'farms', (farmscurrentpagenum - 1) * farmsnoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/followup_Gray.svg"
                       *ngIf="list.status == 'FollowUp'">
                  <img src="../../../../assets/img/marcketconnectreports/close_1.svg" *ngIf="list.status != 'Closed'"
                       title="Close"
                       (click)="statusAction(list.id, list.event, 'close', 'farms', (farmscurrentpagenum - 1) * farmsnoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/close_gray.svg"
                       *ngIf="list.status == 'Closed'">
                  <img src="../../../../assets/img/marcketconnectreports/archive.svg" *ngIf="list.status != 'Archived'"
                       title="Archive"
                       (click)="statusAction(list.id, list.event, 'archive', 'farms', (farmscurrentpagenum - 1) * farmsnoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/archive_gray.svg"
                       *ngIf="list.status == 'Archived'">
                  <img src="../../../../assets/img/marcketconnectreports/assgin.svg" *ngIf="list.status != 'Assigned'"
                       title="Assign"
                       (click)="statusAction(list.id, list.event, 'assigned', 'farms', (farmscurrentpagenum - 1) * farmsnoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/assign_gray.svg"
                       *ngIf="list.status == 'Assigned'">
                </p>
              </td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div> 
          <div *ngIf="dispfarmsfinalData?.length <= 0" class="noDataFoundMessage">No Data Available</div>
        </div>
      </div>
    </div>
    <!--buyers connect details table-->
    <div id="buyerreport">
      <div *ngIf="buyerResponseLoader">
        <div class="adjust">
          <div class="reports-loader"></div>
        </div>
      </div>
      <div class="row card-container farmscard-container" id="buyerCardContainer" *ngIf="showBuyersDetails && !buyerResponseLoader"
           style="margin-top: 2%;margin-bottom: 2%">
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-4">
            <p class="tableheading">Buyer - Report</p>
          </div>
          <div class="col-xs-4">
            <div class="hatcheryglobalicons">
         <span (click)="buyertableCultureSeletion('total'); farmsaddBoxSahadow('total')"
               [ngClass]="buyertableculturetype=='total'?'cultureselected-btn':'cultureunselected-btn'">All</span>
              <span (click)="buyertableCultureSeletion('shrimp'); farmsaddBoxSahadow('shrimp')" title="Shrimp"
                    [ngClass]="buyertableculturetype=='shrimp'?'cultureshrimpselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Shrimp_gray.svg" style="margin-top: 1px;"></span>
              <span (click)="buyertableCultureSeletion('fish'); farmsaddBoxSahadow('fish')" title="Fish"
                    [ngClass]="buyertableculturetype=='fish'?'culturefishselected-btn':'cultureunselected-btn'"><img
                src="../../../../assets/img/marcketconnectreports/Fish.svg" style="margin-top: 1px;"></span>
            </div>
          </div>
          <div class="col-xs-4" style="padding: 0">
            <nav class="navbar tableactions">
              <div class="container-fluid actionpoints">
                <ul class="nav navbar-nav navbar-right">
                  <li (click)="exportExcel('Buyer Report')" title="Export"><a><span><img
                    src="../../../../assets/img/marcketconnectreports/export.svg"></span>Export</a>
                  </li>
                  <li title="Share"><a><span><img src="../../../../assets/img/marcketconnectreports/share.svg"></span>Share</a>
                  </li>
                  <li class="zoomin" (click)="openFullScreen('buyerCardContainer')"><a><img title="Zoom in"
                                                                                            src="../../../../assets/img/marcketconnectreports/Zoomin.svg"
                                                                                            width="18"></a></li>
                  <li class="zoomout" (click)="closeFullScreen()"><a><img title="Zoom out"
                                                                          src="../../../../assets/img/marcketconnectreports/zoomout.svg"
                                                                          width="18"></a></li>
                  <li class="closebtn" (click)="closeTable('buyerdetails')"><a><img title="Close"
                                                                                    src="../../../../assets/img/marcketconnectreports/close.svg"
                                                                                    width="18"></a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div class="row" style="margin-left: 0;margin-right: 0;">
          <div class="col-xs-12" style="border-bottom: 1px solid #ccc;">
            <div class="col-xs-4">
              <div class="row">
                <ul class="nav nav-tabs batch batchtransactiontabs">
                  <li class="active" (click)="buyertableSectionTab('Buyer')"><a data-toggle="tab" href="#Farms">Buyer</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="search">
                <img src="../../../../../../assets/img/png-icons-blubay/search_icon.svg" width="20" height="20" class="search_icon">
                <input type="text" class="search_input" (keyup)="searchLead('buyer', $event)" [(ngModel)]="buyerSearch" name="search" autocomplete="off" placeholder="Search by any field">
                <img src="../../../../../../assets/img/png-icons-blubay/search_close_icon.svg" width="20" height="20" class="search_close" *ngIf="clearBuyerSearchInput" (click)="this.buyerSearch = '';this.clearBuyerSearchInput = false;searchLead('buyer', $event)">
              </div>
            </div>
            <div class="col-xs-4">
              <P class="daysselection">
                <input type="button" class="readingsdays" value="Today"
                       (click)="buyerstableDays('today');"
                       [ngClass]="buyertablenoOfDays=='today'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Week"
                       (click)="buyerstableDays('oneweek');"
                       [ngClass]="buyertablenoOfDays=='oneweek'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Month"
                       (click)="buyerstableDays('onemonth');"
                       [ngClass]="buyertablenoOfDays=='onemonth'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Year"
                       (click)="buyerstableDays('oneyear');"
                       [ngClass]="buyertablenoOfDays=='oneyear'?'selected-btn':'unselected-btn'">
                <input type="button" class="readingsdays" value="Custom" (click)="buyerstableDays('Custom');" *ngIf="customBuyerFromDate == '' && customBuyerToDate == ''"
                       [ngClass]="buyertablenoOfDays=='Custom'?'selected-btn':'unselected-btn'">
                <span (click)="buyerstableDays('Custom');" *ngIf="customBuyerFromDate != '' && customBuyerToDate != ''" [ngClass]="buyertablenoOfDays === 'Custom' || (customBuyerFromDate !== '' && customBuyerToDate !== '') ? 'selected-btn' : 'unselected-btn'">{{ customBuyerFromDate}} - {{ customBuyerToDate }}</span>
              </P>
              <app-date-range-popup
                *ngIf="isBuyerDateRangePopupOpen"
                [fromDate]="customBuyerFromDate"
                [toDate]="customBuyerToDate"
                (close)="closeBuyerDateRangePopup()"
                (apply)="onBuyerDateRangeApply($event)">
              </app-date-range-popup>
            </div>
          </div>
        </div>
        <div class="row table-responsive" style="padding: 12px 14px;">
          <table class="table" *ngIf="(dispbuyerfinalData?.length > 0)">
            <thead>
            <tr>
              <th>S.No</th>
              <th>Date & Time</th>
              <th>Contact Number</th>
              <th>Description</th>
              <th>Status</th>
              <th></th>
            </tr>
            </thead>
            <tbody class="hatcherytablebody">
            <tr class="searchfun buyer-data" (click)="getPersonDetails(list && list.mobileNumber)" [ngClass]="{'hover-highlight': buyerLocationName}"
                *ngFor="let list of dispbuyerfinalData; let i = index">
              <td>{{i+1}}</td>
              <td>{{list && list.generatedDate | date:"dd MMM yyyy"}}</td>
              <td>{{list && list.dialingCode}} {{list && list.mobileNumber ? list && list.mobileNumber : '--'}}</td>
              <td>{{list && list.event ? list && list.event : '--'}}</td>
              <td>{{list && list.status ? list && list.status : '--'}}</td>
              <td>
                <p class="statusaction">
                  <img src="../../../../assets/img/marcketconnectreports/followup.svg" *ngIf="list.status != 'FollowUp'"
                       title="Follow Up"
                       (click)="$event.stopPropagation();statusAction(list.id, list.event, 'follow', 'buyer', (buyercurrentpagenum - 1) * buyernoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/followup_Gray.svg"
                       *ngIf="list.status == 'FollowUp'">
                  <img src="../../../../assets/img/marcketconnectreports/close_1.svg" *ngIf="list.status != 'Closed'"
                       title="Close"
                       (click)="$event.stopPropagation();statusAction(list.id, list.event, 'close', 'buyer', (buyercurrentpagenum - 1) * buyernoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/close_gray.svg"
                       *ngIf="list.status == 'Closed'">
                  <img src="../../../../assets/img/marcketconnectreports/archive.svg" *ngIf="list.status != 'Archived'"
                       title="Archive"
                       (click)="$event.stopPropagation();statusAction(list.id, list.event, 'archive', 'buyer', (buyercurrentpagenum - 1) * buyernoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/archive_gray.svg"
                       *ngIf="list.status == 'Archived'">
                  <img src="../../../../assets/img/marcketconnectreports/assgin.svg" *ngIf="list.status != 'Assigned'"
                       title="Assign"
                       (click)="$event.stopPropagation();statusAction(list.id, list.event, 'assigned', 'buyer', (buyercurrentpagenum - 1) * buyernoofitemsPerPage + i)">
                  <img src="../../../../assets/img/marcketconnectreports/assign_gray.svg"
                       *ngIf="list.status == 'Assigned'">
                </p>
              </td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>  
          <div *ngIf="dispbuyerfinalData?.length == 0" class="noDataFoundMessage">No Data Available</div>
        </div>
      </div>
    </div>
  </div>

  <!--follow up-->
  <div class="modal fade" id="actionModal" role="dialog">
    <div class="modal-dialog modal-lg verifydialog">
      <div class="modal-content verifycontent">
        <div class="modal-header verifyclose">
          <div class="row">
            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
              <p class="demoheading">{{selectedEvent}}</p></div>
            <div class="col-xs-2">
              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">x</button>
            </div>
          </div>
        </div>
        <div class="modal-body otpverifybody">
          <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-12">
                <form class="verifyform" [formGroup]="followupForm">
                  <p><span class="mobilenumber">{{mobileNumber}}</span><a [href]="'tel:' + mobileNumber"> <img
                    src="../../../../assets/img/marcketconnectreports/Call.svg" width="25"/></a></p>
                  <p class="followdate">Follow up date and time {{currentDate}}</p>
                  <div class="row user-input-wrp">
                    <br/>
                    <textarea type="text" name="desc" class="form-control" rows="3"
                              [(ngModel)]="customerLead.status_remarks" required
                              formControlName="description" placeholder="Follow up comment"
                              [ngClass]="{ 'is-invalid': followupSubmitted && f.description.errors}"
                              autocomplete="off"></textarea>
                    <div *ngIf="followupSubmitted && f.description.errors" class="invalid-feedback">
                      <div *ngIf="f.description.errors.required" class="alert-color">Comments mandatory.</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12">
                      <button class="verifybutton" type="button" (click)="followUp()">Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--close-->
  <div class="modal fade" id="closeactionModal" role="dialog">
    <div class="modal-dialog modal-lg verifydialog">
      <div class="modal-content verifycontent">
        <div class="modal-header verifyclose">
          <div class="row">
            <div class="col-xs-10">
              <p class="demoheading">{{selectedEvent}}</p></div>
            <div class="col-xs-2">
              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">x</button>
            </div>
          </div>
        </div>
        <div class="modal-body otpverifybody">
          <div class="row">
            <div class="col-xs-12">
              <div class="col-xs-12">
                <form class="verifyform" [formGroup]="closeForm">
                  <p><span class="mobilenumber">{{mobileNumber}}</span> <a [href]="'tel:' + mobileNumber"><img
                    src="../../../../assets/img/marcketconnectreports/Call.svg" width="25"/></a></p>
                  <p class="followdate" *ngIf="selectedItem && selectedItem.status == 'FollowUp'">Followed
                    on {{selectedItem && selectedItem.status_date}}</p>
                  <p class="closedate">Closer date and time {{currentDate}}</p>
                  <div class="row user-input-wrp">
                    <input type="checkbox" id="pcrreport" name="convert" value="path"
                           [(ngModel)]="customerLead.converted"
                           formControlName="convert">
                    <label class="pcrlabel">Converted</label>
                  </div>
                  <div class="row user-input-wrp">
                    <br/>
                    <textarea type="text" name="closedesc" class="form-control" rows="3"
                              [(ngModel)]="customerLead.status_remarks" required
                              formControlName="closedescription" placeholder="Closer comment"
                              [ngClass]="{ 'is-invalid': closeSubmitted && f1.closedescription.errors}"
                              autocomplete="off"></textarea>
                    <div *ngIf="closeSubmitted && f1.closedescription.errors" class="invalid-feedback">
                      <div *ngIf="f1.closedescription.errors.required" class="alert-color">Comments madatory.</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12">
                      <button class="verifybutton" type="button" (click)="leadClose()">Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--assigned-->
  <div class="modal fade" id="assignactionModal" role="dialog">
    <div class="modal-dialog modal-lg verifydialog">
      <div class="modal-content verifycontent">
        <div class="modal-header verifyclose">
          <div class="row">
            <div class="col-xs-10">
              <p class="demoheading">{{selectedEvent}}</p></div>
            <div class="col-xs-2">
              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">x</button>
            </div>
          </div>
        </div>
        <div class="modal-body otpverifybody">
          <div class="row">
            <div class="col-xs-12">
              <form class="verifyform" [formGroup]="assignedForm">
                <!--                <div class="col-lg-12">-->
                <div class="form-group cursor-pointer">
                  <label class="control-label customerlable">Customer support engineer</label>
                  <select name="devicenumber" [(ngModel)]="assignedId" class="form-control"
                          required formControlName="businessid"
                          [ngClass]="{ 'is-invalid': assignedSubmitted && f2.businessid.errors}">
                    <option value=undefined disabled selected>Choose...</option>
                    <option value="{{person.id}}"
                            *ngFor="let person of persons">{{person.firstName}} {{person.lastName}}</option>
                  </select>
                  <span class="caret history-caret"></span>
                  <div *ngIf="assignedSubmitted && f2.businessid.errors" class="invalid-feedback">
                    <div *ngIf="f2.businessid.errors.required" class="alert-color">Customer is madatory.</div>
                  </div>
                </div>
                <!--                </div>-->
                <div class="row">
                  <p class="assignedmobile">{{mobileNumber}}</p>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <button class="verifybutton" type="button" (click)="assigned()">Assign
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--archive-->
  <div class="modal fade" id="archiveactionModal" role="dialog">
    <div class="modal-dialog modal-lg verifydialog">
      <div class="modal-content verifycontent">
        <div class="modal-header verifyclose">
          <div class="row">
            <div class="col-xs-10">
              <p class="archivedemoheading">{{selectedEvent}}</p></div>
            <div class="col-xs-2">
              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">x</button>
            </div>
          </div>
        </div>
        <div class="modal-body otpverifybody">
          <div class="row">
            <div class="col-xs-12">
              <div class="row">
                <p>You are about to archive the lead. Confirm</p>
                <p class="archivemobile">{{mobileNumber}}</p>
                <p *ngIf="selectedItem && selectedItem.status == 'FollowUp'">Followed
                  on {{selectedItem.status_date}}</p>
                <p *ngIf="selectedItem && selectedItem.status == 'Closed'">Closed/converted
                  on {{selectedItem.status_date}}</p>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <button class="verifybutton" type="button" (click)="archiveYes()">Yes</button>
                  <button class="verifybutton" type="button" (click)="archiveNo()" style="margin-right: 10px;">No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body batch-details-popup">
        <div class="table-responsive">
            <table class="table table-responsive-lg">
              <thead>
              <tr>
                <th>Buyer Name</th>
                <th>Location Name</th>
                <th>Address</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ person && person.firstName }}<span *ngIf="person && person.lastName">{{ person && person.lastName }}</span></td>
                <td>{{ person && person.address && person.address[0].city }}</td>
                <td>{{ person && person.address && person.address[0].city }}, {{ person && person.address && person.address[0].district }}, {{ person && person.address && person.address[0].state }}</td>
              </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>

  </div>
</div>

